import { isEmptyOrSpace } from '../../webmodule-common/other/ui/string-helper-functions';
import { getApiFactory } from './api-injector';

export function getAbsoluteVirtualFilePath(relativeVirtualFilePath: string, alternateFilePath: string = ''): string {
  if (!isEmptyOrSpace(relativeVirtualFilePath)) return getApiFactory().blob().fullUrl(relativeVirtualFilePath);
  else return alternateFilePath;
}
